export default __webpack_public_path__ + "static/media/sn12.3d6775e3.jpg";